export const invoicesMisc = {
  sendLink: {
    title: "Send invoice link",
    already: {
      title: "This reservation already has an issued invoice.",
      onlyOne: "Only <b>1 invoice per reservation</b> is allowed.",
      offerPdf:
        "If you like, we can send you the invoice PDF right now via WhatsApp.",
    },
    openPdf: "Open PDF",
    sendWhatsapp: "Send invoice via WhatsApp",
    sending: "Sending...",
    info: {
      title: "The invoice link will be sent to the guest via WhatsApp.",
      desc: "The guest will complete their tax details from the link and can download their electronic invoice.",
    },
    rule: "<strong>Rule:</strong> only <b>1 invoice per reservation</b> can be issued.",
    accept: "Accept and send",
    toast: {
      invoiceSent: "Invoice sent via WhatsApp.",
      linkSent: "Invoice link sent via WhatsApp.",
    },
    warn: {
      noReservation: "The reservation ID hasn't been found yet.",
    },
    err: {
      sendInvoiceFailed: "The invoice could not be sent via WhatsApp.",
      sendLinkFailed: "The link could not be sent.",
    },
  },
  country: {
    placeholder: "Select a country (optional)",
    noResult: "No results",
  },
  adjust: {
    title: "Adjust {name}",
    type: {
      apartment: "Apartment(s)",
      hotel: "Hotel (Rooms)",
      villa: "Villas",
      camping: "Campsites",
      default: "Accommodations",
    },
    usage: "Current usage",
    available: "Available",
    unitDefault: "units",
    hintReduce:
      "The reduction applies now and does <b>not</b> generate a refund. You'll pay less on your next invoice.",
    unitPriceCurrent: "Current unit price",
    totalBeforeProration: "Total (before proration)",
    prorationNote:
      "A <b>proration</b> will be applied for the days elapsed in the cycle.",
    confirmIncrease: "Confirm increase",
    confirmDecrease: "Confirm reduction",
    err: {
      selectAmount: "Select an amount to adjust.",
      failed: "The operation could not be completed.",
    },
    toast: {
      added: "Units added",
      reduced: "Units reduced",
      addedDetail: "A proration will be applied for the remaining days of the cycle.",
      reducedDetail: "You'll pay less on your next invoice (no refund).",
    },
  },
  menu: {
    title: "My Subscription",
    subtitle: "Manage your subscriptions, invoices and payment methods",
    subscription: "My subscription",
    paymentMethod: "Payment method",
    invoices: "Invoices",
  },
  custom: {
    title: "Custom Plan",
    whatDoYouNeed: "What do you need?",
    salesContact:
      "Our sales team will get in touch with you as soon as possible.",
    tellUs: "Tell us more about your project",
    sentOk: "Sent successfully",
    salesContactShort:
      "The sales team will get in touch as soon as possible",
    contactSales: "Contact sales",
    err: {
      required:
        "You must specify what you need so we can get in touch with you",
      failed: "Sorry, the request could not be processed",
    },
  },
  common: {
    cancel: "Cancel",
    close: "Close",
  },
};
